<script setup lang="ts">
import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { DateService } from '@/coreDomainsModule/services/dateService';
import Mdi from './Mdi.vue';

const t = i18n.t;

const props = withDefaults(
  defineProps<{
    /** modelValueはUnixTimeで受ける想定 */
    modelValue: number;
    placeholder?: string;
    disabled?: boolean;
    format?: string;
    minDate?: Date;
    textCentering?: boolean;
    displayIcon?: boolean;
    autoApply?: boolean;
  }>(),
  {
    placeholder: undefined,
    format: 'yyyy/MM/dd',
    minDate: undefined,
  }
);
const emits = defineEmits<{ (e: 'update:modelValue', value: number) }>();

const locale = computed(() => i18n.locale);
const computedModelValue = computed({
  /** 取得する */
  get: () => props.modelValue,
  /**
   * 設定する
   * @param v - value
   */
  set: (v) => {
    if (!v) return;
    emits('update:modelValue', v);
  },
});
</script>
<template>
  <AppDatePicker
    v-model="computedModelValue"
    model-type="timestamp"
    :mode-height="1"
    :format="format"
    :enable-time-picker="false"
    :month-change-on-scroll="false"
    :teleport="true"
    :locale="locale"
    :placeholder="t('日付を選択')"
    :select-text="t('選択')"
    :cancel-text="t('キャンセル')"
    :show-now-button="true"
    :clearable="false"
    :now-button-label="t('現在を選択')"
    :auto-position="false"
    pad
    :disabled="disabled"
    :min-date="props.minDate"
    :auto-apply="props.autoApply"
  >
    <template #trigger>
      <button class="date-input" :class="{ 'date-input--disabled': disabled, 'date-input--center': textCentering }">
        <Mdi v-if="displayIcon" icon="&#xe935;" />
        <div :class="{ 'date-input--placeholder': !computedModelValue }">
          {{ computedModelValue ? DateService.convertMSUnixTimeToYYYYMMDDSlash(computedModelValue) : placeholder ?? '' }}
        </div>
      </button>
    </template>
  </AppDatePicker>
</template>
<style lang="scss" scoped>
.date-input {
  padding: 7px 8px;
  background-color: $semanticWhite;
  height: 38px;

  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 400;
  line-height: 20.27px;
  text-align: left;
  color: $textDefault;
  width: 100%;

  border: 1px solid transparent;

  display: grid;
  grid-template-columns: max-content max-content;
  gap: 8px;

  &--disabled {
    background-color: $surfaceSecondary;
    color: $textSecondary;
  }

  &--center {
    justify-content: center;
  }

  &--placeholder {
    font-family: Noto Sans JP;
    font-size: 14px;
    font-weight: 400;
    line-height: 20.27px;
    text-align: left;

    color: $textSecondary;
  }
}
</style>
